import * as React from "react";
import styled from "styled-components";

import { CouponItemProps } from "..";
import { CouponBtn } from "./CouponBtn";

// 为cls设置高度
// 宽度固定，高度自适应
const SingleWrapper = styled.div`
	font-size: 0px;
	img {
		width: 100%;
	}
`;

export const Single = (props: CouponItemProps) => {
	const { coupons = [], ...others } = props;
	return (
		<React.Fragment>
			{coupons.map((item, index) => {
				return (
					<SingleWrapper key={index}>
						<CouponBtn index={index} coupon={item} {...others} />
					</SingleWrapper>
				);
			})}
		</React.Fragment>
	);
};
